import { Presets as PresetsModule } from '@modules/presets';
import { Flex } from 'antd';
import styles from './presets.module.scss';

export const Presets = () => (
  <Flex className={styles.root} align="center" justify="center">
    <PresetsModule />
  </Flex>
);
